export default {
  CHAT: {
    TITLE: 'Chats',
    SEARCH: 'Search candidates or jobs',
    ALL: 'All',
    UNREAD: 'Unread',
    OFFERS: 'Filter by job',
    YOU: 'You',
    OFFERS_FILTER: {
      SELECT_OFFERS: 'Select jobs',
      SEARCH: 'Search jobs',
      CANCEL: 'Cancel',
      APPLY_FILTER: 'Apply',
    },
    QUICK_CHAT: {
      TITLE: 'Chat with {{name}}',
      TITLE_FALLBACK: 'Chat',
      SEND: 'Send',
      OPEN_FULL_CHAT: 'Open full chat',
      ATTACHMENT: 'Attachment',
      SEND_ERROR: 'The message could not be sent. Please try again.',
    },
    WRITE_MESSAGE: 'Type a message...',
    DIVIDER: { NEW: 'New' },
    NO_RESULTS: {
      TITLE: 'No results found',
      SUBTITLE: 'Try a different search.',
    },
    NO_CHATS_LIST: {
      TITLE: "You don't have any chats yet",
      SUBTITLE: 'Your conversations with candidates will appear<br>here once you reach out to them.',
    },
    NO_CHATS: 'Select a chat to get started.',
    NO_CHATS_HINT: "If you don't have any chats yet, it's because on Wokap you make the first move: candidates can't message you until you contact them first.",
    NO_MESSAGES: {
      TITLE: 'No messages yet',
      SUBTITLE: 'Send a message to start the conversation.',
    },
    MESSAGE_ATTACHMENT_ERROR: {
      TITLE: 'File type not supported',
      SUBTITLE: 'Please upload an image (JPG, PNG, GIF) or a document (PDF, DOC, DOCX).',
    },
    MESSAGE_DELETED: 'This message was deleted',
    MESSAGE_EDITED: 'Edited',
    EDIT_MESSAGE: {
      TOOLTIP: 'Edit message',
      TITLE: 'Edit message',
      PLACEHOLDER: 'Write new content...',
      MEDIA_NOTE: 'Only the text can be edited. Attachments cannot be modified.',
      CANCEL: 'Cancel',
      SAVE: 'Save',
      SUCCESS_SUMMARY: 'Message edited',
      SUCCESS_DETAIL: 'The message has been updated successfully.',
    },
    DELETE_MESSAGE: {
      TOOLTIP: 'Delete message',
      CONFIRM_TITLE: 'Delete message',
      CONFIRM_BODY: 'Are you sure you want to delete this message? This action cannot be undone.',
      CONFIRM_YES: 'Delete',
      CONFIRM_NO: 'Cancel',
      SUCCESS_SUMMARY: 'Message deleted',
      SUCCESS_DETAIL: 'The message has been deleted successfully.',
    },
    DELETE_CHAT: {
      TOOLTIP: 'Delete conversation',
      CONFIRM_TITLE: 'Delete conversation',
      CONFIRM_BODY: 'Are you sure you want to delete this conversation? All messages will be permanently removed and this action cannot be undone.',
      CONFIRM_YES: 'Delete',
      CONFIRM_NO: 'Cancel',
      SUCCESS_SUMMARY: 'Conversation deleted',
      SUCCESS_DETAIL: 'The conversation has been deleted successfully.',
    },
    ERRORS: {
      MESSAGE_NOT_FOUND: 'Message not found.',
      MESSAGE_NOT_AUTHORIZED: 'You are not authorized to perform this action.',
      MESSAGE_ALREADY_DELETED: 'This message has already been deleted.',
      MESSAGE_EDIT_WINDOW_EXPIRED: 'The edit window for this message has expired (30 minutes).',
      UNKNOWN_ERROR: 'An unexpected error occurred.',
    },
  },
} as const;
